export const range = (start, stop, step = 1) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + (i * step));

export const preventDialogBackdropClick = (action) => (event, reason) => {
    if (!reason || reason !== 'backdropClick') {
        action();
    }
};
